<template>
  <v-dialog v-model="dialog.display" max-width="550px">
    <v-card>
      <v-card-title>
        <span class="text-subtitle-2">
          <span class="font-weight-bold secondary-font">{{
            $t("subscriptions.filter.title")
          }}</span>
        </span>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="px-7 pt-3">
        <v-dialog
          ref="dialog_daterange"
          v-model="dialog_daterange"
          :return-value.sync="daterange.value"
          persistent
          width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="daterange.formatted"
              :label="$t('subscriptions.fields.daterange.title')"
              append-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
              clearable
            ></v-text-field>
          </template>
          <v-date-picker range v-model="daterange.value" scrollable>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="dialog_daterange = false">{{ $t('btn.cancel') }}</v-btn>
            <v-btn text color="primary" @click="confirmChangeDaterange(daterange.value)">
              {{ $t('btn.ok') }}
            </v-btn>
          </v-date-picker>
        </v-dialog>
        <v-text-field
          append-icon="mdi-clipboard-account-outline"
          :label="$t('subscriber.fields.account_number.title')"
          v-model="filters.account_number.value"
          clearable
        ></v-text-field>
        <v-select
          v-model="filters.type.value"
          :item-text="(item) => $t(item.text)"
          :label="$t('cga.fields.subscription_type.title2')"
          :items="items.types"
          clearable
          append-icon="mdi-credit-card-multiple-outline"
        ></v-select>
        <v-select
          v-model="filters.status.value"
          :item-text="(item) => $t(item.text)"
          :label="$t('subscriptions.fields.status.title2')"
          :items="items.statuses"
          clearable
          append-icon="mdi-radiobox-blank"
        ></v-select>
      </v-card-text>
      <v-card-actions class="mt-0 px-5">
        <v-spacer></v-spacer>
        <v-btn text @click="reset()">{{ $t("btn.reset") }}</v-btn>
        <v-btn
          text
          color="primary"
          class="font-weight-bold"
          @click="filter()"
          >{{ $t("btn.filter") }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: {
      type: Object,
      default: function () {
        return {
          display: false,
        };
      },
    },
  },
  data: () => ({
    dialog_daterange: false,
    daterange: {
      value: [],
      formatted: null
    },
    filters: {
      account_number: {
        operator: "$eq",
        value: null,
      },
      type: {
        operator: "$eq",
        value: null,
      },
      status: {
        operator: "$eq",
        value: null,
      },
      created_gte: {
        field: 'created',
        operator: '$gte',
        value: null
      },
      created_lte: {
        field: 'created',
        operator: '$lte',
        value: null
      }
    },
    items: {
      types: [
        { text: "cga.fields.subscription_type.RENEWAL", value: "RENEWAL" },
        { text: "cga.fields.subscription_type.UPGRADE", value: "UPGRADE" },
      ],
      statuses: [
        { text: "subscriptions.fields.status.PENDING", value: "PENDING" },
        { text: "subscriptions.fields.status.ERROR", value: "ERROR" },
        { text: "subscriptions.fields.status.SUCCESS", value: "SUCCESS" },
      ],
    },
  }),
  methods: {
    filter() {
      this.$emit("filter", this.filters);
      this.dialog.display = false;
    },
    reset() {
      this.$emit("filter", {});
      this.daterange.value = [];
      this.daterange.formatted = null;
      for (const prop in this.filters) {
        this.filters[prop].value = null;
      }
      this.dialog.display = false;
    },
    clearDaterange() {
      this.daterange.value = null,
      this.daterange.formatted = null;
      this.filters.created_gte.value = null;
      this.filters.created_lte.value = null;
    },
    confirmChangeDaterange(dates) {
      if(dates.length !== 2) return;
      this.$refs.dialog_daterange.save(this.daterange.value);
      const dates_normalized = this.$utils.normalizeDaterange(dates);
      this.daterange.value = dates_normalized;

      this.daterange.formatted = `${dates_normalized[0]} - ${dates_normalized[1]}`;
      this.filters.created_gte.value = dates_normalized[0];
      this.filters.created_lte.value = dates_normalized[1];
      this.dialog_daterange = false;
    }
  },
  watch: {
    'daterange.formatted'(value) {
      if(!value) {
        this.clearDaterange();
      }
    }
  }
};
</script>